import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["id", "className", "panels", "showConfirm", "operations", "placeholder", "showClear", "icon", "data-component-name", "noSelectorLabel", "popoverAdjustMainSize", "switchPanelChildren", "dropdownButtonPanelLeft"],
    _excluded2 = ["label", "disabled", "echo", "key"],
    _excluded3 = ["render", "type", "key", "operations", "isDisableClose"],
    _excluded4 = ["label", "onClick", "disabled", "value", "buttonProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from '@jd/jmtd-tools/es/classnames';
import { css, px, remove as removeCss } from '@jd/jmtd-tools/es/css';
import { isFunction, isString } from '@jd/jmtd-tools/es/is';
import PropTypes from 'prop-types';
import React from 'react';
import { getLocale } from '../locale';
import { getValue, getValueByCall } from '../tools/util';
import Button from '../Button';
import DropdownButtonPanel from '../DropdownButtonPanel';
import DropdownList from '../DropdownList';
import Icon from '../Icon';
import Select from '../Select';
import Selector from '../Selector';
var sCurrentKey = Symbol('currentKey');
var sPanelStates = Symbol('panelStates');
var sLastValue = Symbol('lastValue');
var sPanels = Symbol('panels');
var keySymbols = {};

function getValueByBind(value, self) {
  if (isFunction(value)) {
    return value.bind(self);
  }

  return value;
} // 判断值是否相等


var isValueEqual = function isValueEqual(l, r) {
  if ((l === null || l === void 0 ? void 0 : l.type) !== (r === null || r === void 0 ? void 0 : r.type)) {
    return false;
  }

  if ((l === null || l === void 0 ? void 0 : l.type) === 'quick') {
    var _map = [l, r].map(function (v) {
      var _v$value = v.value,
          key = _v$value.key,
          value = _v$value.value,
          type = _v$value.type;
      return JSON.stringify({
        key: key,
        value: value,
        type: type
      });
    }),
        _map2 = _slicedToArray(_map, 2),
        lv = _map2[0],
        rv = _map2[1];

    return lv === rv;
  }

  return JSON.stringify(l) === JSON.stringify(r);
};

function DatePicker(_ref) {
  var id = _ref.id,
      className = _ref.className,
      rawPanels = _ref.panels,
      showConfirm = _ref.showConfirm,
      operations = _ref.operations,
      placeholder = _ref.placeholder,
      showClear = _ref.showClear,
      icon = _ref.icon,
      trackComponentName = _ref['data-component-name'],
      noSelectorLabel = _ref.noSelectorLabel,
      popoverAdjustMainSize = _ref.popoverAdjustMainSize,
      switchPanelChildren = _ref.switchPanelChildren,
      dropdownButtonPanelLeft = _ref.dropdownButtonPanelLeft,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var dateSelectProps = {
    onUpdate: function onUpdate(_ref2, _ref3) {
      var dropdown = _ref2.self;
      var state = _ref3.state;
      // 切换时根据最高的面板设置切换面板的高度，以防止各个面板高度不同导致的乱跳
      var open = dropdown.open,
          popoverRef = dropdown.popoverRef;
      var currentKey = state[sCurrentKey],
          panelStates = state[sPanelStates],
          panels = state[sPanels]; // 所有面板的key

      var panelKeys = Object.keys(panelStates).concat(Object.getOwnPropertySymbols(panelStates));

      if (panelKeys.length > 1 && open) {
        var heightTable = state.heightTable = state.heightTable || {};
        var switchPanel = popoverRef.querySelector('.jmtd-date-picker-switch-panel');
        var pickerPanel = popoverRef.querySelector('.jmtd-date-picker-panel');

        if (!switchPanel || !pickerPanel) {
          return;
        }

        var panelType = panels.find(function (x) {
          return x.key === currentKey;
        }); // 设置初始最大高度

        if (panelType !== null && panelType !== void 0 && panelType.defaultMaxHeight) {
          css(pickerPanel, 'max-height', px(panelType.defaultMaxHeight));
        }

        removeCss(switchPanel, 'height'); // 先取消高度，以计算真实高度

        heightTable[currentKey] = switchPanel.offsetHeight; // 获取当前高度

        var newHeight = Math.max.apply(Math, _toConsumableArray(panelKeys.map(function (key) {
          var _heightTable$key;

          return (_heightTable$key = heightTable[key]) !== null && _heightTable$key !== void 0 ? _heightTable$key : 0;
        })));
        css(switchPanel, 'height', px(newHeight)); // 设置高度为面板最大值
        // 更新高度为面板最大值

        if (panelType !== null && panelType !== void 0 && panelType.defaultMaxHeight) {
          css(pickerPanel, 'max-height', px(Math.max(panelType.defaultMaxHeight, newHeight)));
        }
      }
    },
    render: function render(_ref4) {
      var _state$sPanelStates, _Object$assign, _state$sCurrentKey, _panels$find, _ref8;

      var currentValue = _ref4.value,
          state = _ref4.state,
          open = _ref4.open,
          setOpen = _ref4.setOpen,
          _update = _ref4.update,
          change = _ref4.change,
          locale = _ref4.locale;
      var type;
      var value = null;
      var key; // 处理label和echo的本地化

      var panels = rawPanels.map( // eslint-disable-next-line no-return-assign
      function (_ref5, index) {
        var panelLabel = _ref5.label,
            disabled = _ref5.disabled,
            echo = _ref5.echo,
            panelKey = _ref5.key,
            other = _objectWithoutProperties(_ref5, _excluded2);

        return _objectSpread({
          disabled: getValue(disabled),
          label: getValueByCall(panelLabel, {
            locale: locale
          }, {
            setOpen: setOpen
          }),
          echo: getValueByBind(echo, {
            locale: locale
          }),
          key: panelKey !== null && panelKey !== void 0 ? panelKey : keySymbols[index] = keySymbols[index] || Symbol(index)
        }, other);
      }); // 以key为键panel map

      var panelsMapByKey = panels.reduce(function (cur, panel) {
        return _objectSpread(_objectSpread({}, cur), {}, _defineProperty({}, panel.key, panel));
      }, {});
      var timePanel = !!panels.find(function (panel) {
        return panel.timePanel;
      });
      var defaultIcon = /*#__PURE__*/React.createElement(Icon, {
        className: timePanel ? 'jmti-clock' : 'jmti-calendar'
      });

      if (currentValue) {
        type = currentValue.type;
        value = currentValue.value;
        key = currentValue.key;

        // 如果没有label，取type对应面板的label
        if (key == null || !panelsMapByKey[key]) {
          key = panels.find(function (p) {
            return p.type === type;
          }).key;
        }
      } else {
        key = panels[0].key;
      } // 初始化面板状态表


      Object.assign(state, (_Object$assign = {}, _defineProperty(_Object$assign, sPanels, panels), _defineProperty(_Object$assign, sPanelStates, panels.reduce(function (cur, panel) {
        var _cur$panel$key;

        return _objectSpread(_objectSpread({}, cur), {}, _defineProperty({}, panel.key, (_cur$panel$key = cur[panel.key]) !== null && _cur$panel$key !== void 0 ? _cur$panel$key : {}));
      }, (_state$sPanelStates = state[sPanelStates]) !== null && _state$sPanelStates !== void 0 ? _state$sPanelStates : {})), _Object$assign));
      state[sCurrentKey] = (_state$sCurrentKey = state[sCurrentKey]) !== null && _state$sCurrentKey !== void 0 ? _state$sCurrentKey : key;
      var rawCurrentKey = state[sCurrentKey],
          panelStates = state[sPanelStates];
      state[sLastValue] = state[sLastValue] || currentValue; // 上一次的值，用于确定按钮
      // 焦点面板key

      var focusedKey = panelsMapByKey[rawCurrentKey] && (panelsMapByKey[rawCurrentKey].disabled || panelsMapByKey[rawCurrentKey].virtual) ? ((_panels$find = panels.find(function (p) {
        return !p.disabled;
      })) !== null && _panels$find !== void 0 ? _panels$find : panels[0]).key : rawCurrentKey;
      var changeValue = null;
      var _panelsMapByKey$key = panelsMapByKey[key],
          echo = _panelsMapByKey$key.echo,
          panelIcon = _panelsMapByKey$key.icon;

      var _ref6 = panelsMapByKey[focusedKey] || panels[0],
          render = _ref6.render,
          currentType = _ref6.type,
          panelKey = _ref6.key,
          panelOperations = _ref6.operations,
          _ref6$isDisableClose = _ref6.isDisableClose,
          isDisableClose = _ref6$isDisableClose === void 0 ? function () {
        return false;
      } : _ref6$isDisableClose,
          config = _objectWithoutProperties(_ref6, _excluded3); // 焦点面板的值
      // 如果是虚拟面板，为null，如果组件值对应的面板就是焦点面板，取组件的值


      var focusedPanelValue = focusedKey === key ? value : null;

      var _render = render({
        state: panelStates[panelKey],
        // 传入面板的state
        value: focusedPanelValue,
        config: config,
        locale: locale,
        update: function update(nextValue) {
          if (nextValue) {
            changeValue({
              key: focusedKey,
              type: currentType,
              value: nextValue
            });
          } else {
            _update();
          }
        }
      }),
          defaultValue = _render.defaultValue,
          dropdown = _render.dropdown,
          _render$onClose = _render.onClose,
          _onClose = _render$onClose === void 0 ? function () {} : _render$onClose,
          _render$notCloseWhenU = _render.notCloseWhenUpdate,
          notCloseWhenUpdate = _render$notCloseWhenU === void 0 ? false : _render$notCloseWhenU,
          disableCloseByRender = _render.disableClose;

      var disableClose = disableCloseByRender || isDisableClose(focusedPanelValue !== null && focusedPanelValue !== void 0 ? focusedPanelValue : defaultValue);

      changeValue = function changeValue(nextWrappedValue) {
        _update({
          value: nextWrappedValue
        });

        if (!showConfirm && !notCloseWhenUpdate) {
          setOpen(false);
          change(nextWrappedValue);
        }
      };

      var nonVirtualPanel = panels.filter(function (p) {
        return !p.virtual;
      }); // TAG 切换面板

      var switchPanel = nonVirtualPanel.length > 1 && /*#__PURE__*/React.createElement(DropdownList, {
        minWidth: 80,
        className: "jmtd-date-picker-switch-panel"
      }, nonVirtualPanel.map(function (panel, i) {
        var disabled = getValue(panel.disabled);
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: classNames('jmtd-date-picker-switch-panel-item', {
            'jmtd-date-picker-switch-panel-current': focusedKey === panel.key,
            'jmtd-date-picker-switch-panel-selected': key === panel.key,
            'jmtd-date-picker-switch-panel-disabled': disabled
          }),
          onMouseEnter: function onMouseEnter() {
            if (!disabled) {
              state[sCurrentKey] = panel.key;

              _update();
            }
          }
        }, panel.label);
      }), getValue(switchPanelChildren, {
        setOpen: setOpen
      })); // TAG 操作栏
      // TAG 操作按钮

      var operationButtons = operations.map(function (o) {
        return getValue(o, {
          setOpen: setOpen
        });
      }).concat(panelOperations ? panelOperations.map(function (o) {
        o = getValue(o, {
          setOpen: setOpen
        });
        return _objectSpread({
          key: focusedKey,
          type: currentType
        }, o);
      }) : []).filter(function (x) {
        return x;
      }).map(function (_ref7, i) {
        var operationLabel = _ref7.label,
            onClick = _ref7.onClick,
            disabled = _ref7.disabled,
            operationValue = _ref7.value,
            buttonProps = _ref7.buttonProps,
            optionConfig = _objectWithoutProperties(_ref7, _excluded4);

        return /*#__PURE__*/React.createElement(Button, _extends({
          "data-event-name": "operation",
          key: i,
          size: "mini",
          semantic: "primary",
          link: true,
          disabled: getValue(disabled),
          className: "jmtd-date-picker-fast",
          onClick: onClick ? function () {
            onClick({
              setOpen: setOpen
            });
          } : function () {
            delete state[sCurrentKey];
            changeValue(_objectSpread(_objectSpread({}, optionConfig), {}, {
              value: getValue(operationValue)
            }));
          }
        }, buttonProps), getValueByCall(operationLabel, {
          locale: locale
        }, {
          setOpen: setOpen
        }));
      }); // TAG 底部按钮面板

      var dropdownButtonPanel = (showConfirm || showClear || operationButtons.length || dropdownButtonPanelLeft) && /*#__PURE__*/React.createElement(DropdownButtonPanel, {
        left: /*#__PURE__*/React.createElement(React.Fragment, null, operationButtons, getValue(dropdownButtonPanelLeft, {
          setOpen: setOpen
        }))
      }, /*#__PURE__*/React.createElement(React.Fragment, null, showClear && /*#__PURE__*/React.createElement(Button, {
        "data-event-name": "clear",
        size: "mini",
        outline: true,
        onClick: function onClick() {
          changeValue(null);
        }
      }, getLocale(locale).common.clear), showClear && showConfirm && /*#__PURE__*/React.createElement(Button, {
        "data-event-name": "cancel",
        size: "mini",
        outline: true,
        onClick: function onClick() {
          setOpen(false);
        }
      }, getLocale(locale).common.cancel), showConfirm && /*#__PURE__*/React.createElement(Button, {
        "data-event-name": "confirm",
        disabled: disableClose,
        size: "mini",
        semantic: "primary",
        onClick: function onClick() {
          state[sLastValue] = currentValue;
          change(currentValue);
          setOpen(false);
        }
      }, getLocale(locale).common.confirm)));
      return {
        disableClose: !showConfirm && open && disableClose,
        onClose: function onClose() {
          _onClose();

          delete state[sCurrentKey];
          delete state[sPanelStates];

          if (showConfirm) {
            var lastValue = state[sLastValue];
            delete state[sLastValue];
            lastValue && _update({
              value: lastValue
            });
          }

          if (!showConfirm && notCloseWhenUpdate) {
            change(currentValue);
          }
        },
        selector: {
          Component: Selector,
          props: {
            onClick: function onClick() {
              setOpen(!open);
            },
            placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : timePanel ? getLocale(locale).datePicker.pleaseSelectTime : getLocale(locale).datePicker.pleaseSelect,
            icon: (_ref8 = panelIcon !== null && panelIcon !== void 0 ? panelIcon : icon) !== null && _ref8 !== void 0 ? _ref8 : defaultIcon,
            children: value && echo(value, currentValue),
            noLabel: noSelectorLabel
          }
        },
        dropdown: /*#__PURE__*/React.createElement(React.Fragment, null, switchPanel, dropdown),
        dropdownButtonPanel: dropdownButtonPanel,
        dropdownProps: {
          'data-event-name': isString(panelKey) ? panelKey : currentType
        }
      };
    }
  };
  return /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    widthAdaptive: true,
    "data-component-name": trackComponentName,
    className: classNames('jmtd-date-picker', className),
    adjustMainSize: popoverAdjustMainSize
  }, otherProps, dateSelectProps, {
    isValueEqual: isValueEqual
  }));
}

DatePicker.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.any,
    type: PropTypes.string
  }),
  panels: PropTypes.array.isRequired,
  operations: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func])),
  showConfirm: PropTypes.bool,
  showClear: PropTypes.bool,
  width: PropTypes.number,
  icon: PropTypes.node,
  placeholder: PropTypes.string,
  'data-component-name': PropTypes.string,
  noSelectorLabel: PropTypes.bool,
  popoverAdjustMainSize: PropTypes.number,
  switchPanelChildren: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  dropdownButtonPanelLeft: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};
DatePicker.defaultProps = {
  id: null,
  className: '',
  value: null,
  operations: [],
  showConfirm: false,
  showClear: false,
  width: 270,
  icon: null,
  placeholder: null,
  'data-component-name': 'DatePicker',
  noSelectorLabel: false,
  popoverAdjustMainSize: 200,
  switchPanelChildren: null,
  dropdownButtonPanelLeft: null
};
export default DatePicker;